module.exports = __webpack_public_path__ + "static/media/report.1f7bf0a6.svg";